import React, { forwardRef, JSX } from 'react';
import { DateRangeListChip } from '../DateRanges.styles';
import { SingleInputDateRangeFieldProps } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import IsShortcutSelected from '../hooks/useShortcutSelected';
import { useDateRange } from '../DateRanges.context';

interface CustomSingleInputDateRangeFieldProps<TDate> extends SingleInputDateRangeFieldProps<TDate> {
  selected: boolean;
}
type FieldComponent = (<TDate>(
  props: CustomSingleInputDateRangeFieldProps<TDate> & React.RefAttributes<HTMLInputElement>
) => JSX.Element) & { fieldType?: string };

const DateRangeChip = forwardRef(
  (props: CustomSingleInputDateRangeFieldProps<Date>, ref: React.Ref<HTMLInputElement>) => {
    const { label, ...newProps } = props;
    const selected = IsShortcutSelected();

    const { dateRange } = useDateRange();
    return (
      <DateRangeListChip
        label={
          !selected ? `${dateRange[0].format('YYYY-MM-DD')} - ${dateRange[1].format('YYYY-MM-DD')}` : 'Custom Range'
        }
        clickable
        onClick={newProps.onClick}
        selected={!selected ? true : false}
      />
    );
  }
) as FieldComponent;

DateRangeChip.fieldType = 'single-input';
export default DateRangeChip;
